module.exports = `${require.publicPath}police.58f55c5c.png`;